var map = {
	"./date.svg": "70f5",
	"./gallery.svg": "6ec0",
	"./home.svg": "ac9d",
	"./news.svg": "f212",
	"./shop.svg": "5747",
	"./speed.svg": "6c2d",
	"./tractor.svg": "517a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a244";